module.exports = __webpack_public_path__ + "5d5476e94679a9a374e7f29f86a32acd.fbx";